// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    border-radius: 0px !important;
}

::placeholder {
    color: grey !important;
}

.cs-body {
    margin: 0;
    padding: 0;
    position: absolute;
    background-image: linear-gradient(0deg, rgba(255, 255, 255, .50), rgba(255, 255, 255, 0));
    background-repeat: no-repeat;
    background-size: 100%;
    width: 100%;
    height: 200px;
}

.custom-theme .p-disabled {
    background: grey !important;
}

.cs-header {
    clear: both;
    width: 100%;
    margin: 0px auto;
}

.itemrow {
    padding-bottom: 8px;
}
.coloumn {
    margin-left: 5px;
}

 .grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px; 
    background-color: #eeee e;
    padding: 10px;
    color: black;
    clear: both;
    margin-left: 10px;
}

.top-left {
    position: absolute;
    top: 40px;
    left: 40px;
    z-index: 999;
}

.header-details {
    margin: 0px;
    padding: 20px 0px;
    position: relative;
}

.header-details h1,
.header-details h5,
.header-details p {
    margin: 0;
    padding: 0;
}

.header-details h1 {
    margin: 0px;
    padding: 30px 15px 10px 0px;
    text-align: center;
    font-weight: 400;
}

:host ::ng-deep #fileInput plusicon {
    visibility: hidden;
}

:host ::ng-deep #fileInput plusicon:before {
    content: "\\e934" !important;
    visibility: visible !important;
}

.header-details h5 {
    margin: 0px;
    padding: 5px 15px 10px 0px;
    text-align: center;
    font-size: 1em;
    font-weight: 400;
}

.navbar-default .wps-menu>div {
    display: none;
}

tr:nth-child(even) {
    background-color: whitesmoke;
    vertical-align: middle;
}

tr:nth-child(odd) {
    background-color: white;
    vertical-align: middle;
}

#tblTypeBody:nth-child(even) {
    background-color: whitesmoke;
    vertical-align: middle;
}

#tblTypeBody:nth-child(odd) {
    background-color: rgb(250, 250, 250);
    vertical-align: middle;
}

.top-right {
    position: absolute;
    top: 20px;
    right: 25px;
    font-size: 25px;
    cursor: pointer;
}

.modal {
    position: absolute;
    top: 50px;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100000000;
    display: block;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    outline: 0;
}

.modal-dialog {
    width: 520px;
    margin: 30px auto;
    position: fixed;
    bottom: 70px;
    right: 80px;
}

.modal-body {
    padding: 15px 25px 25px 25px !important;
}

.modal-footer {
    padding: 0px;
    border-top-color: transparent;
    box-shadow: none;
    background-color: white !important;
}

.modal-header {
    padding: 6px;
    border-bottom: 1px solid transparent;
    background-color: #165788 !important;
}

.modal-title {
    margin: 5px;
    line-height: 1.428571;
    color: aliceblue;
    font-size: 14px;
}

.tblPermitTemplate {
    width: 98%;
    table-layout: fixed;
}

.clsLogo {
    height: 51px;
    width: 180px;
    padding-right: 5px;
    margin-top: 7px;
}

.clsLogoHidden {
    height: 45px;
    width: 157px;
    padding-right: 5px;
    padding-top: 10px;
    padding-bottom: -5px;
}

.mapImage {
    height: 800px !important;
}

.clsHeader {
    color: White;
    background-color: #1F4E78;
    font-size: 30px;
    padding: 10px;
    font-weight: bold;
    margin-left: -20px;
}

.clsHeaderWithoutImage {
    color: White;
    background-color: #1F4E78;
    font-size: 30px;
    padding: 10px;
    font-weight: bold;
    width: 83%;
}

.clsHeaderHiddenChild {
    background-color: White;
    width: 30px;
    height: 100%;
    position: absolute;
    left: 10px;
}



.clsHeaderHidden {
    color: White;
    background-color: #1F4E78;
    font-size: 50px;
    font-weight: bold;
    width: 100%;
    text-align: center;
}

.clsHeaderHiddenWithoutImage {
    color: White;
    background-color: #1F4E78;
    font-size: 50px;
    font-weight: bold;
    width: 100%;
    text-align: center;
}



.tblPermitTemplate tr th {
    background-color: #1F4E78;
    color: white;
    font-size: 20px !important;
    text-indent: 10px !important;
}

.tblForApprover {
    width: 98%;
}

.tblForApprover td {
    
    background-color: white;
}

.tblForApprover tr {
    border: 1px solid white;
}

.tblForApprover tr th {
    color: white;
}

.tblForApprover tr td,
.tblForApprover tr th {
    padding: 6px;
}

.tblPermitTemplate tr td,
.tblPermitTemplate tr th {
    padding: 6px;
}

.clsValue {
    color: black;
    margin-left: 5px;
}

.clsTextArea {
    color: black;
    border: 1px solid #1F4E78;
    resize: none;
    margin-top: 5px;
    margin-left: 25px;
}

.clsTable {
    margin: 0px 5px 0px 0px;
    width: calc(100% - 40px);
}

.display-block-padding-bottom-6 {
    display: block;
    padding-bottom: 6px;
}

.display-iblock-margin-bottom-4 {
    display: inline-block;
    margin-bottom: 4px;
}

.display-block-margin-bottom-4 {
    display: inline-block;
    margin-bottom: 4px;
}

.display-block-position-abs {
    display: inline-block;
    position: absolute;
}

.display-block-margin-top-3 {
    display: inline-block;
    margin-top: 3px;
    position: absolute;
}

.display-padding-right-20 {
    padding-right: 20px;
}

.display-padding-0 {
    padding-left: 0;
}

.clsTableSQ {
    margin: 0px 5px 0px 0px;
    width: calc(100% - 20px);
}

.clsTable td {
    border: 2px solid white !important;
}

.clsTable th {
    border: 2px solid white !important;
}

.clsTablesContainer {
    overflow: auto;
    margin-bottom: 5px;
}

.clsBgWhite {
    background-color: white;
}

.clsHeaderParent {
    width: 98.7%;
    padding-left: 30px;
    background-color: White;
}

#pnlPreviewTemp {
    background-color: white;
    position: relative;
    top: -100px;
    padding-left: 30px;
    padding-top: 30px;
    padding-right: 30px;
}

.clsCheckboxContainer {
    padding: 5px;
    color: black;
}

.clsCheckBox {
    height: 80px;
    overflow: auto;
}

.clsCheckboxDownContainer {
    padding: 5px 5px 5px 20px;
    color: black;
    word-break: break-all;
}

.clsRadioContainer {
    padding: 5px 5px 5px 0px;
    color: black;
    word-break: break-all;
}

.btn-primary {
    margin-right: 5px !important;
}

.btn-permit {
    margin-left: 15px !important;
    border-radius: 50% !important;
    font-size: 22px;
    background-color: #165688 !important;
    cursor: pointer;
}

.btn-permit-disabled {
    margin-left: 15px !important;
    border-radius: 50% !important;
    font-size: 22px;
    background-color: #165688 !important;
    cursor: not-allowed !important;
}


.div-buttons {
    z-index: 5;
    position: fixed;
    bottom: -7%;
    margin-bottom: 9vh;
    display: flex;
    flex-direction: row-reverse;
    right: 45px;
}

.comment {
    z-index: 5;
    position: fixed;
    bottom: -7%;
    margin-bottom: 68px;
    justify-content: flex-start;
    display: flex;
    margin-left: 36px !important;
}

:host ::ng-deep .p-toast .p-toast-message-info {
    background: #b7d8b7 !important;
    border: 0 none;
    color: #212121;
}

:host ::ng-deep .p-toast .p-toast-close-icon {
    color: #070707 !important;
}

:host ::ng-deep .p-toast .p-toast-message-content {
    padding: 0px !important;
}

:host ::ng-deep .ui-inputtext {
    margin: 0;
    outline: medium none;
    padding: .25em;
    font-weight: normal;
}

:host ::ng-deep input[type=text] {
    border-radius: 0px !important;
}

:host ::ng-deep input[disabled] {
    color: #101010 !important;
    background-color: white !important;
    font-size: 15px !important;
    text-indent: 12px !important;
}

.no-hover-input:hover {
    border-color: rgba(10, 10, 10, 0.25) !important;
}

:host ::ng-deep button[disabled] {
    font-size: 20px !important;
    opacity: 0.5;
    cursor: not-allowed;
}

:host ::ng-deep .ui-radiobutton-box.ui-state-active {
    border-color: grey !important;
    background-color: white !important;
    color: #ffffff !important;
}

:host ::ng-deep .ui-radiobutton-box.ui-state-active .ui-radiobutton-icon {
    background-color: #0075ff !important;
}



:host ::ng-deep .p-toast .p-toast-close-icon {
    color: #ffffff !important;

}

*/ .toast-header {
    background-color: #165788;
    color: #FFF;
    padding: 1px 1px 1px 10px !important;
}

.approveMessage {
    font-style: italic;
    font-weight: normal;
    font-size: 11px;
}

.permitTypeImages {
    width: 70px;
    height: 71px;
}

#messagebox {
    border: solid 1px #cecece;
    color: #4B515D;
}

#messagebox.success {
    padding: 10px;
}

.success-color {
    color: transparent;
}

.status {
    padding: 2px;
    font-size: 13px;
}

.message-header {
    font-size: 14px;
    font-weight: bold;
}

.message-border {
    height: auto;
    width: 560px;
    margin-top: -10px;
}

.body .p-overlaypanel .p-overlaypanel-content {
    padding: 0.571em 1.8em !important;
}

.imgclose {
    margin-left: 37px;
}

.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12 {
    float: left;
}

:host ::ng-deep .p-component {
    font-size: 13px !important;
    clear: both;
}

.status-overlay {
    position: absolute;
    right: 46px;
    top: 28px;
    width: 128px;
    height: 33px;
    padding-top: 7px;
    cursor: pointer;
    background-color: #33aaff;
    color: #FFF !important;
    background-position: -496px -229px;
    padding-left: 13px;
    letter-spacing: 0.5px;
    font-size: 14px;
    text-align: center;

}


.filter-bar {
    display: flex;
    flex-shrink: 0;
    background: rgb(222 219 219 / 100%);
    padding: 4px 8px 4px 8px;
    border-radius: 2px;
    margin-top: 8px;
    margin-bottom: 8px;
    overflow: hidden;
}

.filter-bar-list {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    padding-left: 0;
    width: 100%;
}

.filter-bar-item {
    flex-shrink: 0;
    max-width: 100%;
    padding-left: 8px;
    padding-right: 8px;
}

.filter-bar-right-item {
    display: flex;
    flex-shrink: 0;
    margin-left: 8px;
}



.flex-grow {
    flex-grow: 1;
}

.flex-column {
    display: flex;
    flex-direction: column;
}

.flex-center {
    align-items: center;
}

.flex-row {
    display: flex;
    flex-direction: row;
}

.status-overlay1 {


    top: 28px;

    height: 33px;
    padding-top: 7px;
    cursor: pointer;
    background-color: #33aaff;
    color: #FFF !important;
    background-position: -496px -229px;
    padding-left: 13px;
    letter-spacing: 0.5px;
    font-size: 14px;
    text-align: center;

}

.geo-tag {
    position: fixed;
    right: 52px;
    top: 8%;
    width: 76px;
    height: 23px;
    margin-left: 12px;
    padding-top: 2px;
    cursor: pointer;
}

#commentBoxContainer {
    background-color: white;
    height: 400px;
    position: sticky;
    top: 87px;
    z-index: 1000;
    right: 643px;
    margin-left: 5px;
    border: 1px solid #165788;
    border-radius: 5px 5px 0px 0px !important;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
    max-height: 400px;
    width: 98.5%;
}

/* .permit-no-wrap {
  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-break: break-word !important;
  display: block;
  max-width: 96%; /* or set a specific value like 400px 
} */

.permit-no-wrap,
.permit-no-wrap p,
.permit-no-wrap span {
    word-break: normal !important;
    overflow-wrap: normal !important;
    white-space: normal !important;
    hyphens: none !important;
    padding-right: 2px;
}

.tblPermitTemplate td {
    overflow-wrap: break-word;
}

.msg_send_btn:focus {
    border: 0px solid black !important;
}

.userImage {
    height: 80px !important;
    width: 72px !important;
    padding: 2px !important;
    border: 2px solid #165788 !important;
}

.status-user-tab {
    background: #2d9494eb;
    color: white;
    padding-top: 0px;
    cursor: default;
}

.cursor-pointer {
    cursor: pointer;
}

.msg_send_btn {
    border: 0px solid black !important;
}

.disabled {
    cursor: not-allowed;
    pointer-events: none;
}

hr {
    clear: both;
    margin-top: 10px;
    margin-bottom: 10px;
}

.vertical-label-5 {
    box-sizing: border-box;
    padding: 0px 0px 0px 20px;
    font: 13px !important;
    position: relative;
    left: 0 !important;
}

.vertical-label-5-25 {
    box-sizing: border-box;
    padding: 0px 0px 0px 25px;
    font: 13px !important;
    position: relative;
    left: 0 !important;
}

.vertical-label-10 {
    box-sizing: border-box;
    padding: 0px 0px 0px 25px;
    font: 13px !important;
    top: 10px ! important;
    position: relative;
    left: 0 !important;
}

.hiddenDiv {
    
    overflow: hidden;
    height: 0;
    
}

#pnlPreview {
    position: relative;
    padding-left: 30px;
    padding-top: 0px;
    
}

.paper-permit-file-row {
  display: flex;
  align-items: center;
  gap: 24px; /* Adjust spacing as needed */
}

.paper-permit-file-name {
  font-size: 14px;
  font-weight: 500;
  min-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.paper-permit-file-box {
  background: #f7fafd;
  padding: 16px 24px;
  margin: 12px 0;
  box-shadow: 0 2px 8px rgba(34,125,193,0.08);
  display: inline-block;
}

.paper-permit-icon {
  font-size: 20px;
  cursor: pointer;
  margin-right: 8px;
  color: #227dc1;
  transition: color 0.2s;
}

.paper-permit-icon:hover {
  color: #165788;
}

.left {
    display: table-cell;
}

#btnPaperPermit {
    height: 50px;
    width: 49px;
    margin-top: 6px;
}

.middle {
    display: table-cell;
    width: 100%;
}

.right {
    display: table-cell;
    width: 10%;
}

.hover-pointer {
    cursor: pointer;
}

.tooltip-icon {
  margin-left: 2px;
  cursor: pointer !important;
  margin-top: 4px;
}

.tooltip-info {
  color: #007ad9;
}

.clsTablesContainer td {
    border-color: Gray !important;
}

.disabled {
    cursor: not-allowed !important;
    pointer-events: none;
}

:host ::ng-deep .ui-datepicker table td {
    padding: 0 !important;
    margin-top: 10px !important;
}

::ng-deep label {
    /* Add your custom css property value. */


    font-weight: normal;
    margin-top: 5px;
}

.clsMandatory {
    border-color: red !important;
}

.pageNum {
    font-family: "DejaVu Sans", "Arial", sans-serif;
    position: absolute;
    bottom: 25px;
    right: 65px;
    font-size: 15px;
}

.btn-permit:hover {
    border-color: none;
    transform: scale(1.3);
}

.export-button-active {
    cursor: pointer;
}

.export-button-disabled {
    cursor: not-allowed;
    filter: grayscale(1);
    opacity: 0.6;
    pointer-events: none;
}

.export-button:hover {
    transform: scale(1.15);
}

.export-button-2:hover {
   
    transform: scale(1.05);
}


kendo-pdf-export {
    font-family: "DejaVu Sans", "Arial", "sans-serif";
    
}

@font-face {
    font-family: "DejaVu Sans";
    src: url("https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans.ttf") format("truetype");
}

@font-face {
    font-family: "DejaVu Sans";
    font-weight: bold;
    src: url("https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Bold.ttf") format("truetype");
}

@font-face {
    font-family: "DejaVu Sans";
    font-style: italic;
    src: url("https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf") format("truetype");
}

@font-face {
    font-family: "DejaVu Sans";
    font-weight: bold;
    font-style: italic;
    src: url("https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf") format("truetype");
}

.input-checkbox-medium {
    font-size: 12px;
}

:host ::ng-deep .ui-button {
    
    margin-top: 8px;
    color: #007ad9;
    background-color: white;
    border: 1px#fff;
    font-size: 14px;
    transition: background-color 0.2s, box-shadow 0.2s;
}

:host ::ng-deep #fileInput .pi-plus:before {
    content: "\\e934" !important;
}

:host ::ng-deep .p-fileupload-file-size {
    display: none !important;
}

:host ::ng-deep .ui-fileupload-choose:not(.ui-state-disabled):hover {
    background-color: white !important;
    color: #116fbf !important;
    border-color: white !important;
}

:host ::ng-deep .ui-button-icon-only .ui-button-icon-left {
    
    left: 50%;
    margin-top: -50px;
    margin-left: -8px;
    width: 1em;
    height: 1em;
    color: black;
    font-size: 24px;
}

:host ::ng-deep .ui-state-disabled.ui-button-icon-only .ui-button-icon-left {
    
    left: 50%;
    margin-top: -50px;
    margin-left: -15px;
    width: 1em;
    height: 1em;
    color: black;
}

.btnToggle-1 {
    background-color: #fff !important;
    color: #165788 !important;
    border: none;
    font-size: 13px;
}

.btnToggle-2 {
    background-color: #165788 !important;
    color: #fff !important;
    border: none;
    font-size: 13px;
}

:host ::ng-deep .ui-button.ui-button-icon-only .ui-button-text {
    padding: 0.429em;
    display: none;
}

:host ::ng-deep .ui-calendar.ui-calendar-w-btn .ui-inputtext {
    border-right: 1px solid #0a0a0a40 !important;
    text-indent: 30px !important;
    
}

.tablecss {
    position: relative !important;
    margin-left: 15px !important;
    margin-right: 15px !important;
}

:host ::ng-deep .p-multiselect .p-multiselect-trigger {
    background-color: rgb(204, 204, 204) !important;
}

.Filtergrid {
    background-color: rgb(222 219 219 / 100%) !important;
    padding: 0px !important;
}

.manual-permit-fields {
    width: 94%;
    display: grid;
}

:host ::ng-deep .manual-permit-fields .p-overlay {
    width: -moz-fit-content;
    width: fit-content;
}

:host ::ng-deep .p-fileupload .p-fileupload-row>div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

:host ::ng-deep .grid-bg-primary {
    background-color: rgb(1, 152, 225) !important;
}

:host ::ng-deep .manual-grid-bg-primary {
    background-color: transparent !important;
}

:host ::ng-deep #permitDialog .p-dialog .p-dialog-header {
    background-color: rgb(1, 152, 225) !important;
    height: 48px;
}

:host ::ng-deep #actionpopoup .p-dialog .p-dialog-header {
    background-color: rgb(1, 152, 225) !important;
    color: #fff !important;
    padding: 7px !important;
}

:host ::ng-deep #actionpopoup .p-dialog .p-dialog-header-icon span {
    color: #fff !important;
}

.grid-icon {
    margin-left: 16px;
}

:host ::ng-deep .p-datatable .p-datatable-tbody>tr>td {
    padding: 0.571rem 0.857rem !important;
}

:host ::ng-deep #permitDialog .p-datatable .p-datatable-tbody>tr>td {
    border: none;
    border-bottom: 1px solid #c8c8c8 !important;
    padding: 10px 6px !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    max-width: 400px !important;
    max-height: 150px !important;
    overflow: hidden !important;
}

:host ::ng-deep .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    color: #ffffff !important;
}

:host ::ng-deep .p-paginator .p-paginator-pages .p-paginator-page {
    color: #848484 !important;
}

:host ::ng-deep .p-paginator-element {
    color: #333333 !important;
}

:host ::ng-deep .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler {
    color: #665f5f !important;
}

:host ::ng-deep #permitDialog .p-dialog .p-dialog-content {
    padding: 0px !important;
    background-color: rgb(234 232 232) !important;
}
:host ::ng-deep  .paper-permit-content .p-dialog-content {
    padding: 0px !important;
    height: 200px;
    background-color: #fff !important;
}

:host ::ng-deep #permitDialog .p-datatable .p-datatable-wrapper {
    max-height: unset !important;
    clear: both;
    float: left;
    width: 100%;
}

:host ::ng-deep #permitDialog .p-dialog .p-dialog-header .p-dialog-title {
    color: #fff !important;
    font-size: 13px !important;
}

:host ::ng-deep #permitDialog .p-link {
    font-size: 13px !important;
}

:host ::ng-deep #permitDialog .p-dialog .p-dialog-header-icon span {
    color: #fff !important;
    margin-top: 13px !important;
    font-weight: 700 !important;
}

:host ::ng-deep #permitDialog .p-dialog .p-dialog-footer {
    border: none !important;
    background: rgb(222 219 219 / 100%) !important;
    margin-top: -25px !important;
}

:host ::ng-deep .p-tree .p-tree-container .p-treenode {
    margin-top: 8px !important;
}

:host ::ng-deep #permitDialog .p-dialog {
    top: 0% !important;
   
    background-color: #EAE8E8;
}

:host ::ng-deep #permitDialog .p-datatable-scrollable-body {
    max-height: 60vh !important;
}

:host ::ng-deep #permitDialog .p-dialog .p-dialog-header-icon span {
    height: 25px !important;

}

:host ::ng-deep #btnfilter .btn-primary:focus {
    background-color: #020b12 !important;
    border-color: #428BCA;
    border-radius: 6px;
}

 

.closelabel {
    top: -35px;
    position: relative;
    left: 95.3%;
    color: #fff;
}

.borderless-table {
    width: 100% !important;
    margin-bottom: 20px !important;
    margin-top: 5px;
}

.borderless-table tr td {
    border-top: none;
    
    background: rgb(232, 232, 232) !important;
    
}

.borderless-table>tr>td>input,
select {
    width: calc(100% - 15px) !important;
}

.borderless-table td {
    width: 25% !important;
}

:host ::ng-deep .borderless-dialog .ui-panel-content {
    border: 0px !important;
}

:host ::ng-deep .borderless-dialog .p-dialog-header {
    border: 0px !important;
}

:host ::ng-deep .borderless-dialog>div {
    border: 0px !important;
}

.dynamiclabel {
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    max-width: 140px !important;
    max-height: 150px !important;
    overflow: hidden;
    padding-left: 0px;
    margin-bottom: 0px !important;
}

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape) {
    :host ::ng-deep #permitDialog .p-datatable-scrollable-body {
        max-height: 56vh !important;
    }
}


:host ::ng-deep #configureApproverDialog .p-dialog .p-dialog-header .p-dialog-title {
    margin: 0 !important;
    float: left !important;
}

:host ::ng-deep #configureApproverDialog .p-dialog-header-maximize {
    float: left !important;
}

:host ::ng-deep .ui-autocomplete.ui-autocomplete-multiple .ui-autocomplete-multiple-container {
    padding: 0.2145em 0.429em !important;
    width: 100% !important;
}

:host ::ng-deep .ui-autocomplete.ui-autocomplete-multiple .ui-autocomplete-multiple-container .ui-autocomplete-input-token input {
    font-size: 13px !important;
}

.ui-steps .ui-steps-item {
    width: 25%;
}

.ui-steps.steps-custom {
    margin-bottom: 30px;
}

.ui-steps.steps-custom .ui-steps-item .ui-menuitem-link {
    height: 10px;
    padding: 0 1em;
}

.ui-steps.steps-custom .ui-steps-item .ui-steps-number {
    background-color: #0081c2;
    color: #FFFFFF;
    display: inline-block;
    width: 36px;
    border-radius: 50%;
    margin-top: -14px;
    margin-bottom: 10px;
}

.ui-steps.steps-custom .ui-steps-item .ui-steps-title {
    color: #555555;
}

#unique_panel {
    display: none;
}

.asset-div {
    background-color: #f2faff !important;
    border: 1px solid #ede9d8;
}

.wo-div {
   
    background-color: #ffffff !important;
    border: 1px solid #ede9d8;
    margin: 10px;
    padding: 5px;
    margin-left: 3.4em;
    width: 90% !important;
}

.op-div {
    background-color: #ffffff !important;
    border: 1px solid #ede9d8;
    margin: 10px;
    padding: 5px;
}

.btn-add-asset {
    
    background-color: #1fa300;
    color: white;
    font-size: 16px !important;
    padding: 6px !important;
    border-radius: 3px !important;
    margin-left: 20px;
    min-width: 120px;
}

.btn-add-asset> .required-icon {
    font-size: 25px;
    color: red;
    position: absolute;
    margin-top: -10px;
}

.btn-add-asset-bottom {
    margin: 5px 0px 5px 0px;
    background-color: #1fa300;
    color: white;
    font-size: 16px !important;
    padding: 6px !important;
    border-radius: 3px !important;

}

.btn-add-wo {
    background-color: #1fa300;
    margin: -5px 70px 0px 8px;
    color: white;
    font-size: 16px !important;
    padding: 6px !important;
    border-radius: 3px !important;
    float: right;
}

.btn-add-wo-only {
    background-color: #1fa300;
    margin: -5px 0px 0px 8px;
    color: white;
    font-size: 16px !important;
    padding: 6px !important;
    border-radius: 3px !important;
    float: right;
}

.btn-disable {
    opacity: 0.5;
    pointer-events: none;
    display: none;
}

.div-block {
    display: block;
}

.div-hidden {
    display: none;
}

ul.timeline {
    list-style-type: none;
    position: relative;
}

ul.timeline:before {
    content: ' ';
    background: #d4d9df;
    display: inline-block;
    position: absolute;
    left: 29px;
    width: 2px;
    height: 100%;
    z-index: 400;
}

ul.timeline>li {
    margin: 20px 0;
    /* padding-left: 20px; */
}

ul.timeline>li:before {
    content: ' ';
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid #22c0e8;
    left: 20px;
    width: 20px;
    height: 20px;
    z-index: 400;
}

.wo-eye-icon {
    float: left;
    padding: 4px 0px 0px 10px;
    color: #33B8FF;
    cursor: pointer;
}

.wo-desc-wrap {
    white-space: nowrap;
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;

}



:host ::ng-deep .p-toast,
.h5,
h5 {
    padding: 0 !important;
    padding-left: 5px !important;
}

.display-padding-left-15 {
    padding-left: 15px;
}

.display-padding-left-5 {
    padding-left: 5px;
}

:host ::ng-deep .p-checkbox {
    position: absolute !important;
}

:host ::ng-deep .p-multiselect-items {
    margin: 0 !important;
}

:host ::ng-deep .p-dropdown-items {
    margin: 0 !important;
}

:host ::ng-deep .p-multiselect-item span {
    margin-left: 25px !important;
}

:host ::ng-deep .p-multiselect-item .p-checkbox .p-checkbox-box span {
    margin-left: 0px !important;
}

:host ::ng-deep #mlSelDesc .p-multiselect-item {
    white-space: normal;
    width: 100%;
    display: inline-block;
    padding-left: 34px;
    text-indent: -25px;
    min-width: auto !important;
}

:host ::ng-deep .p-multiselect-item .p-checkbox .p-checkbox-box span {
    padding-left: 35px !important;
}

:host ::ng-deep .p-checkbox p-component {
    padding-top: 5px !important;
}

:host ::ng-deep .p-multiselect .p-multiselect-label {
    padding: 0.429rem 0.429rem;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
    max-width: 250px;
}

:host ::ng-deep .p-overlay {
    width: 100%;
}

:host ::ng-deep .p-datepicker table th {
    padding: 0.5rem;
    text-align: center;
}

:host ::ng-deep .p-button-danger {
    color: #f44336;
    border-color: #f44336;
}

:host ::ng-deep .p-button-danger .pi {
    margin-right: 0.5rem;
}

.question-text-offset-45 {
    width: calc(100% - 45px);
}
/* Tooltip styling */

.tooltip-text {
  color: #7f7f7f;
  font-weight: 100;
  margin-left: 2px;
  font-size: 14px;
  font-style: italic;
}

.tooltip-info {
  color: #007ad9;
}
.tooltip-warning {
  color: #ffcc00;
}
.tooltip-error {
  color: #ed4337;
}
.tooltip-icon {
  margin-left: 2px;
  cursor: pointer !important;
  margin-top: 4px;
}
:host ::ng-deep .p-fileupload .p-fileupload-content {
    border: none !important;
}

:host ::ng-deep .p-fileupload .p-fileupload-buttonbar {
    border: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/permit/permit.component.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,yFAAyF;IACzF,4BAA4B;IAC5B,qBAAqB;IACrB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;;CAEC;IACG,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;IAGI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,iCAAiC;IACjC,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;;;AAIA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;;;AAIA;IACI,yBAAyB;IACzB,YAAY;IACZ,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,eAAe;IACf,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,eAAe;IACf,oCAAoC;IACpC,8BAA8B;AAClC;;;AAGA;IACI,UAAU;IACV,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,UAAU;IACV,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;IAClC,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;;;AAIA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;;;;;;;;;;IAYI,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,kCAAkC;IAClC,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;;AAEtB;;;AAGA;IACI,aAAa;IACb,cAAc;IACd,mCAAmC;IACnC,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;AACpB;;;;AAIA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;IAGI,SAAS;;IAET,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,kCAAkC;IAClC,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,yCAAyC;IACzC,4EAA4E;IAC5E,iBAAiB;IACjB,YAAY;AAChB;;AAEA;;;;;;GAMG;;AAEH;;;IAGI,6BAA6B;IAC7B,gCAAgC;IAChC,8BAA8B;IAC9B,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,SAAS;;AAEb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,6BAA6B;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;;;IAGxC,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;;AAGA;IACI,iDAAiD;;AAErD;;AAEA;IACI,0BAA0B;IAC1B,0GAA0G;AAC9G;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,+GAA+G;AACnH;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,kHAAkH;AACtH;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,kHAAkH;AACtH;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;;IAEI,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,4CAA4C;IAC5C,4BAA4B;;AAEhC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,6CAA6C;IAC7C,YAAY;AAChB;;AAEA;IACI,6CAA6C;IAC7C,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,2CAA2C;IAC3C,4BAA4B;IAC5B,kCAAkC;IAClC,8BAA8B;IAC9B,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,6CAA6C;AACjD;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;IAC5B,WAAW;IACX,WAAW;IACX,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,8CAA8C;IAC9C,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;;IAElB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,kBAAkB;AACtB;;;;AAIA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,gBAAgB;;IAEhB,yCAAyC;;AAE7C;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,2BAA2B;IAC3B,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;;AAGA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;IACpC,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;IACzB,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;;AAEjC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;;AAE3B;;;;AAIA;;;IAGI,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,iFAAiF;IACjF,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;AACA,oBAAoB;;AAEpB;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":["* {\r\n    border-radius: 0px !important;\r\n}\r\n\r\n::placeholder {\r\n    color: grey !important;\r\n}\r\n\r\n.cs-body {\r\n    margin: 0;\r\n    padding: 0;\r\n    position: absolute;\r\n    background-image: linear-gradient(0deg, rgba(255, 255, 255, .50), rgba(255, 255, 255, 0));\r\n    background-repeat: no-repeat;\r\n    background-size: 100%;\r\n    width: 100%;\r\n    height: 200px;\r\n}\r\n\r\n.custom-theme .p-disabled {\r\n    background: grey !important;\r\n}\r\n\r\n.cs-header {\r\n    clear: both;\r\n    width: 100%;\r\n    margin: 0px auto;\r\n}\r\n\r\n.itemrow {\r\n    padding-bottom: 8px;\r\n}\r\n.coloumn {\r\n    margin-left: 5px;\r\n}\r\n\r\n .grid-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    gap: 20px; \r\n    background-color: #eeee e;\r\n    padding: 10px;\r\n    color: black;\r\n    clear: both;\r\n    margin-left: 10px;\r\n}\r\n\r\n.top-left {\r\n    position: absolute;\r\n    top: 40px;\r\n    left: 40px;\r\n    z-index: 999;\r\n}\r\n\r\n.header-details {\r\n    margin: 0px;\r\n    padding: 20px 0px;\r\n    position: relative;\r\n}\r\n\r\n.header-details h1,\r\n.header-details h5,\r\n.header-details p {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.header-details h1 {\r\n    margin: 0px;\r\n    padding: 30px 15px 10px 0px;\r\n    text-align: center;\r\n    font-weight: 400;\r\n}\r\n\r\n:host ::ng-deep #fileInput plusicon {\r\n    visibility: hidden;\r\n}\r\n\r\n:host ::ng-deep #fileInput plusicon:before {\r\n    content: \"\\e934\" !important;\r\n    visibility: visible !important;\r\n}\r\n\r\n.header-details h5 {\r\n    margin: 0px;\r\n    padding: 5px 15px 10px 0px;\r\n    text-align: center;\r\n    font-size: 1em;\r\n    font-weight: 400;\r\n}\r\n\r\n.navbar-default .wps-menu>div {\r\n    display: none;\r\n}\r\n\r\ntr:nth-child(even) {\r\n    background-color: whitesmoke;\r\n    vertical-align: middle;\r\n}\r\n\r\ntr:nth-child(odd) {\r\n    background-color: white;\r\n    vertical-align: middle;\r\n}\r\n\r\n#tblTypeBody:nth-child(even) {\r\n    background-color: whitesmoke;\r\n    vertical-align: middle;\r\n}\r\n\r\n#tblTypeBody:nth-child(odd) {\r\n    background-color: rgb(250, 250, 250);\r\n    vertical-align: middle;\r\n}\r\n\r\n.top-right {\r\n    position: absolute;\r\n    top: 20px;\r\n    right: 25px;\r\n    font-size: 25px;\r\n    cursor: pointer;\r\n}\r\n\r\n.modal {\r\n    position: absolute;\r\n    top: 50px;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: 100000000;\r\n    display: block;\r\n    overflow: hidden;\r\n    -webkit-overflow-scrolling: touch;\r\n    outline: 0;\r\n}\r\n\r\n.modal-dialog {\r\n    width: 520px;\r\n    margin: 30px auto;\r\n    position: fixed;\r\n    bottom: 70px;\r\n    right: 80px;\r\n}\r\n\r\n.modal-body {\r\n    padding: 15px 25px 25px 25px !important;\r\n}\r\n\r\n.modal-footer {\r\n    padding: 0px;\r\n    border-top-color: transparent;\r\n    box-shadow: none;\r\n    background-color: white !important;\r\n}\r\n\r\n.modal-header {\r\n    padding: 6px;\r\n    border-bottom: 1px solid transparent;\r\n    background-color: #165788 !important;\r\n}\r\n\r\n.modal-title {\r\n    margin: 5px;\r\n    line-height: 1.428571;\r\n    color: aliceblue;\r\n    font-size: 14px;\r\n}\r\n\r\n.tblPermitTemplate {\r\n    width: 98%;\r\n    table-layout: fixed;\r\n}\r\n\r\n.clsLogo {\r\n    height: 51px;\r\n    width: 180px;\r\n    padding-right: 5px;\r\n    margin-top: 7px;\r\n}\r\n\r\n.clsLogoHidden {\r\n    height: 45px;\r\n    width: 157px;\r\n    padding-right: 5px;\r\n    padding-top: 10px;\r\n    padding-bottom: -5px;\r\n}\r\n\r\n.mapImage {\r\n    height: 800px !important;\r\n}\r\n\r\n.clsHeader {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 30px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    margin-left: -20px;\r\n}\r\n\r\n.clsHeaderWithoutImage {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 30px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    width: 83%;\r\n}\r\n\r\n.clsHeaderHiddenChild {\r\n    background-color: White;\r\n    width: 30px;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 10px;\r\n}\r\n\r\n\r\n\r\n.clsHeaderHidden {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 50px;\r\n    font-weight: bold;\r\n    width: 100%;\r\n    text-align: center;\r\n}\r\n\r\n.clsHeaderHiddenWithoutImage {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 50px;\r\n    font-weight: bold;\r\n    width: 100%;\r\n    text-align: center;\r\n}\r\n\r\n\r\n\r\n.tblPermitTemplate tr th {\r\n    background-color: #1F4E78;\r\n    color: white;\r\n    font-size: 20px !important;\r\n    text-indent: 10px !important;\r\n}\r\n\r\n.tblForApprover {\r\n    width: 98%;\r\n}\r\n\r\n.tblForApprover td {\r\n    \r\n    background-color: white;\r\n}\r\n\r\n.tblForApprover tr {\r\n    border: 1px solid white;\r\n}\r\n\r\n.tblForApprover tr th {\r\n    color: white;\r\n}\r\n\r\n.tblForApprover tr td,\r\n.tblForApprover tr th {\r\n    padding: 6px;\r\n}\r\n\r\n.tblPermitTemplate tr td,\r\n.tblPermitTemplate tr th {\r\n    padding: 6px;\r\n}\r\n\r\n.clsValue {\r\n    color: black;\r\n    margin-left: 5px;\r\n}\r\n\r\n.clsTextArea {\r\n    color: black;\r\n    border: 1px solid #1F4E78;\r\n    resize: none;\r\n    margin-top: 5px;\r\n    margin-left: 25px;\r\n}\r\n\r\n.clsTable {\r\n    margin: 0px 5px 0px 0px;\r\n    width: calc(100% - 40px);\r\n}\r\n\r\n.display-block-padding-bottom-6 {\r\n    display: block;\r\n    padding-bottom: 6px;\r\n}\r\n\r\n.display-iblock-margin-bottom-4 {\r\n    display: inline-block;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.display-block-margin-bottom-4 {\r\n    display: inline-block;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.display-block-position-abs {\r\n    display: inline-block;\r\n    position: absolute;\r\n}\r\n\r\n.display-block-margin-top-3 {\r\n    display: inline-block;\r\n    margin-top: 3px;\r\n    position: absolute;\r\n}\r\n\r\n.display-padding-right-20 {\r\n    padding-right: 20px;\r\n}\r\n\r\n.display-padding-0 {\r\n    padding-left: 0;\r\n}\r\n\r\n.clsTableSQ {\r\n    margin: 0px 5px 0px 0px;\r\n    width: calc(100% - 20px);\r\n}\r\n\r\n.clsTable td {\r\n    border: 2px solid white !important;\r\n}\r\n\r\n.clsTable th {\r\n    border: 2px solid white !important;\r\n}\r\n\r\n.clsTablesContainer {\r\n    overflow: auto;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.clsBgWhite {\r\n    background-color: white;\r\n}\r\n\r\n.clsHeaderParent {\r\n    width: 98.7%;\r\n    padding-left: 30px;\r\n    background-color: White;\r\n}\r\n\r\n#pnlPreviewTemp {\r\n    background-color: white;\r\n    position: relative;\r\n    top: -100px;\r\n    padding-left: 30px;\r\n    padding-top: 30px;\r\n    padding-right: 30px;\r\n}\r\n\r\n.clsCheckboxContainer {\r\n    padding: 5px;\r\n    color: black;\r\n}\r\n\r\n.clsCheckBox {\r\n    height: 80px;\r\n    overflow: auto;\r\n}\r\n\r\n.clsCheckboxDownContainer {\r\n    padding: 5px 5px 5px 20px;\r\n    color: black;\r\n    word-break: break-all;\r\n}\r\n\r\n.clsRadioContainer {\r\n    padding: 5px 5px 5px 0px;\r\n    color: black;\r\n    word-break: break-all;\r\n}\r\n\r\n.btn-primary {\r\n    margin-right: 5px !important;\r\n}\r\n\r\n.btn-permit {\r\n    margin-left: 15px !important;\r\n    border-radius: 50% !important;\r\n    font-size: 22px;\r\n    background-color: #165688 !important;\r\n    cursor: pointer;\r\n}\r\n\r\n.btn-permit-disabled {\r\n    margin-left: 15px !important;\r\n    border-radius: 50% !important;\r\n    font-size: 22px;\r\n    background-color: #165688 !important;\r\n    cursor: not-allowed !important;\r\n}\r\n\r\n\r\n.div-buttons {\r\n    z-index: 5;\r\n    position: fixed;\r\n    bottom: -7%;\r\n    margin-bottom: 9vh;\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    right: 45px;\r\n}\r\n\r\n.comment {\r\n    z-index: 5;\r\n    position: fixed;\r\n    bottom: -7%;\r\n    margin-bottom: 68px;\r\n    justify-content: flex-start;\r\n    display: flex;\r\n    margin-left: 36px !important;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message-info {\r\n    background: #b7d8b7 !important;\r\n    border: 0 none;\r\n    color: #212121;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-close-icon {\r\n    color: #070707 !important;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message-content {\r\n    padding: 0px !important;\r\n}\r\n\r\n:host ::ng-deep .ui-inputtext {\r\n    margin: 0;\r\n    outline: medium none;\r\n    padding: .25em;\r\n    font-weight: normal;\r\n}\r\n\r\n:host ::ng-deep input[type=text] {\r\n    border-radius: 0px !important;\r\n}\r\n\r\n:host ::ng-deep input[disabled] {\r\n    color: #101010 !important;\r\n    background-color: white !important;\r\n    font-size: 15px !important;\r\n    text-indent: 12px !important;\r\n}\r\n\r\n.no-hover-input:hover {\r\n    border-color: rgba(10, 10, 10, 0.25) !important;\r\n}\r\n\r\n:host ::ng-deep button[disabled] {\r\n    font-size: 20px !important;\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}\r\n\r\n:host ::ng-deep .ui-radiobutton-box.ui-state-active {\r\n    border-color: grey !important;\r\n    background-color: white !important;\r\n    color: #ffffff !important;\r\n}\r\n\r\n:host ::ng-deep .ui-radiobutton-box.ui-state-active .ui-radiobutton-icon {\r\n    background-color: #0075ff !important;\r\n}\r\n\r\n\r\n\r\n:host ::ng-deep .p-toast .p-toast-close-icon {\r\n    color: #ffffff !important;\r\n\r\n}\r\n\r\n*/ .toast-header {\r\n    background-color: #165788;\r\n    color: #FFF;\r\n    padding: 1px 1px 1px 10px !important;\r\n}\r\n\r\n.approveMessage {\r\n    font-style: italic;\r\n    font-weight: normal;\r\n    font-size: 11px;\r\n}\r\n\r\n.permitTypeImages {\r\n    width: 70px;\r\n    height: 71px;\r\n}\r\n\r\n#messagebox {\r\n    border: solid 1px #cecece;\r\n    color: #4B515D;\r\n}\r\n\r\n#messagebox.success {\r\n    padding: 10px;\r\n}\r\n\r\n.success-color {\r\n    color: transparent;\r\n}\r\n\r\n.status {\r\n    padding: 2px;\r\n    font-size: 13px;\r\n}\r\n\r\n.message-header {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n}\r\n\r\n.message-border {\r\n    height: auto;\r\n    width: 560px;\r\n    margin-top: -10px;\r\n}\r\n\r\n.body .p-overlaypanel .p-overlaypanel-content {\r\n    padding: 0.571em 1.8em !important;\r\n}\r\n\r\n.imgclose {\r\n    margin-left: 37px;\r\n}\r\n\r\n.col-1,\r\n.col-2,\r\n.col-3,\r\n.col-4,\r\n.col-5,\r\n.col-6,\r\n.col-7,\r\n.col-8,\r\n.col-9,\r\n.col-10,\r\n.col-11,\r\n.col-12 {\r\n    float: left;\r\n}\r\n\r\n:host ::ng-deep .p-component {\r\n    font-size: 13px !important;\r\n    clear: both;\r\n}\r\n\r\n.status-overlay {\r\n    position: absolute;\r\n    right: 46px;\r\n    top: 28px;\r\n    width: 128px;\r\n    height: 33px;\r\n    padding-top: 7px;\r\n    cursor: pointer;\r\n    background-color: #33aaff;\r\n    color: #FFF !important;\r\n    background-position: -496px -229px;\r\n    padding-left: 13px;\r\n    letter-spacing: 0.5px;\r\n    font-size: 14px;\r\n    text-align: center;\r\n\r\n}\r\n\r\n\r\n.filter-bar {\r\n    display: flex;\r\n    flex-shrink: 0;\r\n    background: rgb(222 219 219 / 100%);\r\n    padding: 4px 8px 4px 8px;\r\n    border-radius: 2px;\r\n    margin-top: 8px;\r\n    margin-bottom: 8px;\r\n    overflow: hidden;\r\n}\r\n\r\n.filter-bar-list {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-wrap: nowrap;\r\n    padding-left: 0;\r\n    width: 100%;\r\n}\r\n\r\n.filter-bar-item {\r\n    flex-shrink: 0;\r\n    max-width: 100%;\r\n    padding-left: 8px;\r\n    padding-right: 8px;\r\n}\r\n\r\n.filter-bar-right-item {\r\n    display: flex;\r\n    flex-shrink: 0;\r\n    margin-left: 8px;\r\n}\r\n\r\n\r\n\r\n.flex-grow {\r\n    flex-grow: 1;\r\n}\r\n\r\n.flex-column {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.flex-center {\r\n    align-items: center;\r\n}\r\n\r\n.flex-row {\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.status-overlay1 {\r\n\r\n\r\n    top: 28px;\r\n\r\n    height: 33px;\r\n    padding-top: 7px;\r\n    cursor: pointer;\r\n    background-color: #33aaff;\r\n    color: #FFF !important;\r\n    background-position: -496px -229px;\r\n    padding-left: 13px;\r\n    letter-spacing: 0.5px;\r\n    font-size: 14px;\r\n    text-align: center;\r\n\r\n}\r\n\r\n.geo-tag {\r\n    position: fixed;\r\n    right: 52px;\r\n    top: 8%;\r\n    width: 76px;\r\n    height: 23px;\r\n    margin-left: 12px;\r\n    padding-top: 2px;\r\n    cursor: pointer;\r\n}\r\n\r\n#commentBoxContainer {\r\n    background-color: white;\r\n    height: 400px;\r\n    position: sticky;\r\n    top: 87px;\r\n    z-index: 1000;\r\n    right: 643px;\r\n    margin-left: 5px;\r\n    border: 1px solid #165788;\r\n    border-radius: 5px 5px 0px 0px !important;\r\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.25);\r\n    max-height: 400px;\r\n    width: 98.5%;\r\n}\r\n\r\n/* .permit-no-wrap {\r\n  white-space: normal !important;\r\n  overflow-wrap: break-word !important;\r\n  word-break: break-word !important;\r\n  display: block;\r\n  max-width: 96%; /* or set a specific value like 400px \r\n} */\r\n\r\n.permit-no-wrap,\r\n.permit-no-wrap p,\r\n.permit-no-wrap span {\r\n    word-break: normal !important;\r\n    overflow-wrap: normal !important;\r\n    white-space: normal !important;\r\n    hyphens: none !important;\r\n    padding-right: 2px;\r\n}\r\n\r\n.tblPermitTemplate td {\r\n    overflow-wrap: break-word;\r\n}\r\n\r\n.msg_send_btn:focus {\r\n    border: 0px solid black !important;\r\n}\r\n\r\n.userImage {\r\n    height: 80px !important;\r\n    width: 72px !important;\r\n    padding: 2px !important;\r\n    border: 2px solid #165788 !important;\r\n}\r\n\r\n.status-user-tab {\r\n    background: #2d9494eb;\r\n    color: white;\r\n    padding-top: 0px;\r\n    cursor: default;\r\n}\r\n\r\n.cursor-pointer {\r\n    cursor: pointer;\r\n}\r\n\r\n.msg_send_btn {\r\n    border: 0px solid black !important;\r\n}\r\n\r\n.disabled {\r\n    cursor: not-allowed;\r\n    pointer-events: none;\r\n}\r\n\r\nhr {\r\n    clear: both;\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.vertical-label-5 {\r\n    box-sizing: border-box;\r\n    padding: 0px 0px 0px 20px;\r\n    font: 13px !important;\r\n    position: relative;\r\n    left: 0 !important;\r\n}\r\n\r\n.vertical-label-5-25 {\r\n    box-sizing: border-box;\r\n    padding: 0px 0px 0px 25px;\r\n    font: 13px !important;\r\n    position: relative;\r\n    left: 0 !important;\r\n}\r\n\r\n.vertical-label-10 {\r\n    box-sizing: border-box;\r\n    padding: 0px 0px 0px 25px;\r\n    font: 13px !important;\r\n    top: 10px ! important;\r\n    position: relative;\r\n    left: 0 !important;\r\n}\r\n\r\n.hiddenDiv {\r\n    \r\n    overflow: hidden;\r\n    height: 0;\r\n    \r\n}\r\n\r\n#pnlPreview {\r\n    position: relative;\r\n    padding-left: 30px;\r\n    padding-top: 0px;\r\n    \r\n}\r\n\r\n.paper-permit-file-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 24px; /* Adjust spacing as needed */\r\n}\r\n\r\n.paper-permit-file-name {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  min-width: 180px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.paper-permit-file-box {\r\n  background: #f7fafd;\r\n  padding: 16px 24px;\r\n  margin: 12px 0;\r\n  box-shadow: 0 2px 8px rgba(34,125,193,0.08);\r\n  display: inline-block;\r\n}\r\n\r\n.paper-permit-icon {\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  margin-right: 8px;\r\n  color: #227dc1;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.paper-permit-icon:hover {\r\n  color: #165788;\r\n}\r\n\r\n.left {\r\n    display: table-cell;\r\n}\r\n\r\n#btnPaperPermit {\r\n    height: 50px;\r\n    width: 49px;\r\n    margin-top: 6px;\r\n}\r\n\r\n.middle {\r\n    display: table-cell;\r\n    width: 100%;\r\n}\r\n\r\n.right {\r\n    display: table-cell;\r\n    width: 10%;\r\n}\r\n\r\n.hover-pointer {\r\n    cursor: pointer;\r\n}\r\n\r\n.tooltip-icon {\r\n  margin-left: 2px;\r\n  cursor: pointer !important;\r\n  margin-top: 4px;\r\n}\r\n\r\n.tooltip-info {\r\n  color: #007ad9;\r\n}\r\n\r\n.clsTablesContainer td {\r\n    border-color: Gray !important;\r\n}\r\n\r\n.disabled {\r\n    cursor: not-allowed !important;\r\n    pointer-events: none;\r\n}\r\n\r\n:host ::ng-deep .ui-datepicker table td {\r\n    padding: 0 !important;\r\n    margin-top: 10px !important;\r\n}\r\n\r\n::ng-deep label {\r\n    /* Add your custom css property value. */\r\n\r\n\r\n    font-weight: normal;\r\n    margin-top: 5px;\r\n}\r\n\r\n.clsMandatory {\r\n    border-color: red !important;\r\n}\r\n\r\n.pageNum {\r\n    font-family: \"DejaVu Sans\", \"Arial\", sans-serif;\r\n    position: absolute;\r\n    bottom: 25px;\r\n    right: 65px;\r\n    font-size: 15px;\r\n}\r\n\r\n.btn-permit:hover {\r\n    border-color: none;\r\n    transform: scale(1.3);\r\n}\r\n\r\n.export-button-active {\r\n    cursor: pointer;\r\n}\r\n\r\n.export-button-disabled {\r\n    cursor: not-allowed;\r\n    filter: grayscale(1);\r\n    opacity: 0.6;\r\n    pointer-events: none;\r\n}\r\n\r\n.export-button:hover {\r\n    transform: scale(1.15);\r\n}\r\n\r\n.export-button-2:hover {\r\n   \r\n    transform: scale(1.05);\r\n}\r\n\r\n\r\nkendo-pdf-export {\r\n    font-family: \"DejaVu Sans\", \"Arial\", \"sans-serif\";\r\n    \r\n}\r\n\r\n@font-face {\r\n    font-family: \"DejaVu Sans\";\r\n    src: url(\"https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans.ttf\") format(\"truetype\");\r\n}\r\n\r\n@font-face {\r\n    font-family: \"DejaVu Sans\";\r\n    font-weight: bold;\r\n    src: url(\"https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Bold.ttf\") format(\"truetype\");\r\n}\r\n\r\n@font-face {\r\n    font-family: \"DejaVu Sans\";\r\n    font-style: italic;\r\n    src: url(\"https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf\") format(\"truetype\");\r\n}\r\n\r\n@font-face {\r\n    font-family: \"DejaVu Sans\";\r\n    font-weight: bold;\r\n    font-style: italic;\r\n    src: url(\"https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf\") format(\"truetype\");\r\n}\r\n\r\n.input-checkbox-medium {\r\n    font-size: 12px;\r\n}\r\n\r\n:host ::ng-deep .ui-button {\r\n    \r\n    margin-top: 8px;\r\n    color: #007ad9;\r\n    background-color: white;\r\n    border: 1px#fff;\r\n    font-size: 14px;\r\n    transition: background-color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n:host ::ng-deep #fileInput .pi-plus:before {\r\n    content: \"\\e934\" !important;\r\n}\r\n\r\n:host ::ng-deep .p-fileupload-file-size {\r\n    display: none !important;\r\n}\r\n\r\n:host ::ng-deep .ui-fileupload-choose:not(.ui-state-disabled):hover {\r\n    background-color: white !important;\r\n    color: #116fbf !important;\r\n    border-color: white !important;\r\n}\r\n\r\n:host ::ng-deep .ui-button-icon-only .ui-button-icon-left {\r\n    \r\n    left: 50%;\r\n    margin-top: -50px;\r\n    margin-left: -8px;\r\n    width: 1em;\r\n    height: 1em;\r\n    color: black;\r\n    font-size: 24px;\r\n}\r\n\r\n:host ::ng-deep .ui-state-disabled.ui-button-icon-only .ui-button-icon-left {\r\n    \r\n    left: 50%;\r\n    margin-top: -50px;\r\n    margin-left: -15px;\r\n    width: 1em;\r\n    height: 1em;\r\n    color: black;\r\n}\r\n\r\n.btnToggle-1 {\r\n    background-color: #fff !important;\r\n    color: #165788 !important;\r\n    border: none;\r\n    font-size: 13px;\r\n}\r\n\r\n.btnToggle-2 {\r\n    background-color: #165788 !important;\r\n    color: #fff !important;\r\n    border: none;\r\n    font-size: 13px;\r\n}\r\n\r\n:host ::ng-deep .ui-button.ui-button-icon-only .ui-button-text {\r\n    padding: 0.429em;\r\n    display: none;\r\n}\r\n\r\n:host ::ng-deep .ui-calendar.ui-calendar-w-btn .ui-inputtext {\r\n    border-right: 1px solid #0a0a0a40 !important;\r\n    text-indent: 30px !important;\r\n    \r\n}\r\n\r\n.tablecss {\r\n    position: relative !important;\r\n    margin-left: 15px !important;\r\n    margin-right: 15px !important;\r\n}\r\n\r\n:host ::ng-deep .p-multiselect .p-multiselect-trigger {\r\n    background-color: rgb(204, 204, 204) !important;\r\n}\r\n\r\n.Filtergrid {\r\n    background-color: rgb(222 219 219 / 100%) !important;\r\n    padding: 0px !important;\r\n}\r\n\r\n.manual-permit-fields {\r\n    width: 94%;\r\n    display: grid;\r\n}\r\n\r\n:host ::ng-deep .manual-permit-fields .p-overlay {\r\n    width: fit-content;\r\n}\r\n\r\n:host ::ng-deep .p-fileupload .p-fileupload-row>div {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n:host ::ng-deep .grid-bg-primary {\r\n    background-color: rgb(1, 152, 225) !important;\r\n}\r\n\r\n:host ::ng-deep .manual-grid-bg-primary {\r\n    background-color: transparent !important;\r\n}\r\n\r\n:host ::ng-deep #permitDialog .p-dialog .p-dialog-header {\r\n    background-color: rgb(1, 152, 225) !important;\r\n    height: 48px;\r\n}\r\n\r\n:host ::ng-deep #actionpopoup .p-dialog .p-dialog-header {\r\n    background-color: rgb(1, 152, 225) !important;\r\n    color: #fff !important;\r\n    padding: 7px !important;\r\n}\r\n\r\n:host ::ng-deep #actionpopoup .p-dialog .p-dialog-header-icon span {\r\n    color: #fff !important;\r\n}\r\n\r\n.grid-icon {\r\n    margin-left: 16px;\r\n}\r\n\r\n:host ::ng-deep .p-datatable .p-datatable-tbody>tr>td {\r\n    padding: 0.571rem 0.857rem !important;\r\n}\r\n\r\n:host ::ng-deep #permitDialog .p-datatable .p-datatable-tbody>tr>td {\r\n    border: none;\r\n    border-bottom: 1px solid #c8c8c8 !important;\r\n    padding: 10px 6px !important;\r\n    text-overflow: ellipsis !important;\r\n    white-space: nowrap !important;\r\n    max-width: 400px !important;\r\n    max-height: 150px !important;\r\n    overflow: hidden !important;\r\n}\r\n\r\n:host ::ng-deep .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {\r\n    color: #ffffff !important;\r\n}\r\n\r\n:host ::ng-deep .p-paginator .p-paginator-pages .p-paginator-page {\r\n    color: #848484 !important;\r\n}\r\n\r\n:host ::ng-deep .p-paginator-element {\r\n    color: #333333 !important;\r\n}\r\n\r\n:host ::ng-deep .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler {\r\n    color: #665f5f !important;\r\n}\r\n\r\n:host ::ng-deep #permitDialog .p-dialog .p-dialog-content {\r\n    padding: 0px !important;\r\n    background-color: rgb(234 232 232) !important;\r\n}\r\n:host ::ng-deep  .paper-permit-content .p-dialog-content {\r\n    padding: 0px !important;\r\n    height: 200px;\r\n    background-color: #fff !important;\r\n}\r\n\r\n:host ::ng-deep #permitDialog .p-datatable .p-datatable-wrapper {\r\n    max-height: unset !important;\r\n    clear: both;\r\n    float: left;\r\n    width: 100%;\r\n}\r\n\r\n:host ::ng-deep #permitDialog .p-dialog .p-dialog-header .p-dialog-title {\r\n    color: #fff !important;\r\n    font-size: 13px !important;\r\n}\r\n\r\n:host ::ng-deep #permitDialog .p-link {\r\n    font-size: 13px !important;\r\n}\r\n\r\n:host ::ng-deep #permitDialog .p-dialog .p-dialog-header-icon span {\r\n    color: #fff !important;\r\n    margin-top: 13px !important;\r\n    font-weight: 700 !important;\r\n}\r\n\r\n:host ::ng-deep #permitDialog .p-dialog .p-dialog-footer {\r\n    border: none !important;\r\n    background: rgb(222 219 219 / 100%) !important;\r\n    margin-top: -25px !important;\r\n}\r\n\r\n:host ::ng-deep .p-tree .p-tree-container .p-treenode {\r\n    margin-top: 8px !important;\r\n}\r\n\r\n:host ::ng-deep #permitDialog .p-dialog {\r\n    top: 0% !important;\r\n   \r\n    background-color: #EAE8E8;\r\n}\r\n\r\n:host ::ng-deep #permitDialog .p-datatable-scrollable-body {\r\n    max-height: 60vh !important;\r\n}\r\n\r\n:host ::ng-deep #permitDialog .p-dialog .p-dialog-header-icon span {\r\n    height: 25px !important;\r\n\r\n}\r\n\r\n:host ::ng-deep #btnfilter .btn-primary:focus {\r\n    background-color: #020b12 !important;\r\n    border-color: #428BCA;\r\n    border-radius: 6px;\r\n}\r\n\r\n \r\n\r\n.closelabel {\r\n    top: -35px;\r\n    position: relative;\r\n    left: 95.3%;\r\n    color: #fff;\r\n}\r\n\r\n.borderless-table {\r\n    width: 100% !important;\r\n    margin-bottom: 20px !important;\r\n    margin-top: 5px;\r\n}\r\n\r\n.borderless-table tr td {\r\n    border-top: none;\r\n    \r\n    background: rgb(232, 232, 232) !important;\r\n    \r\n}\r\n\r\n.borderless-table>tr>td>input,\r\nselect {\r\n    width: calc(100% - 15px) !important;\r\n}\r\n\r\n.borderless-table td {\r\n    width: 25% !important;\r\n}\r\n\r\n:host ::ng-deep .borderless-dialog .ui-panel-content {\r\n    border: 0px !important;\r\n}\r\n\r\n:host ::ng-deep .borderless-dialog .p-dialog-header {\r\n    border: 0px !important;\r\n}\r\n\r\n:host ::ng-deep .borderless-dialog>div {\r\n    border: 0px !important;\r\n}\r\n\r\n.dynamiclabel {\r\n    text-overflow: ellipsis !important;\r\n    white-space: nowrap !important;\r\n    max-width: 140px !important;\r\n    max-height: 150px !important;\r\n    overflow: hidden;\r\n    padding-left: 0px;\r\n    margin-bottom: 0px !important;\r\n}\r\n\r\n@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape) {\r\n    :host ::ng-deep #permitDialog .p-datatable-scrollable-body {\r\n        max-height: 56vh !important;\r\n    }\r\n}\r\n\r\n\r\n:host ::ng-deep #configureApproverDialog .p-dialog .p-dialog-header .p-dialog-title {\r\n    margin: 0 !important;\r\n    float: left !important;\r\n}\r\n\r\n:host ::ng-deep #configureApproverDialog .p-dialog-header-maximize {\r\n    float: left !important;\r\n}\r\n\r\n:host ::ng-deep .ui-autocomplete.ui-autocomplete-multiple .ui-autocomplete-multiple-container {\r\n    padding: 0.2145em 0.429em !important;\r\n    width: 100% !important;\r\n}\r\n\r\n:host ::ng-deep .ui-autocomplete.ui-autocomplete-multiple .ui-autocomplete-multiple-container .ui-autocomplete-input-token input {\r\n    font-size: 13px !important;\r\n}\r\n\r\n.ui-steps .ui-steps-item {\r\n    width: 25%;\r\n}\r\n\r\n.ui-steps.steps-custom {\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.ui-steps.steps-custom .ui-steps-item .ui-menuitem-link {\r\n    height: 10px;\r\n    padding: 0 1em;\r\n}\r\n\r\n.ui-steps.steps-custom .ui-steps-item .ui-steps-number {\r\n    background-color: #0081c2;\r\n    color: #FFFFFF;\r\n    display: inline-block;\r\n    width: 36px;\r\n    border-radius: 50%;\r\n    margin-top: -14px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.ui-steps.steps-custom .ui-steps-item .ui-steps-title {\r\n    color: #555555;\r\n}\r\n\r\n#unique_panel {\r\n    display: none;\r\n}\r\n\r\n.asset-div {\r\n    background-color: #f2faff !important;\r\n    border: 1px solid #ede9d8;\r\n}\r\n\r\n.wo-div {\r\n   \r\n    background-color: #ffffff !important;\r\n    border: 1px solid #ede9d8;\r\n    margin: 10px;\r\n    padding: 5px;\r\n    margin-left: 3.4em;\r\n    width: 90% !important;\r\n}\r\n\r\n.op-div {\r\n    background-color: #ffffff !important;\r\n    border: 1px solid #ede9d8;\r\n    margin: 10px;\r\n    padding: 5px;\r\n}\r\n\r\n.btn-add-asset {\r\n    \r\n    background-color: #1fa300;\r\n    color: white;\r\n    font-size: 16px !important;\r\n    padding: 6px !important;\r\n    border-radius: 3px !important;\r\n    margin-left: 20px;\r\n    min-width: 120px;\r\n}\r\n\r\n.btn-add-asset> .required-icon {\r\n    font-size: 25px;\r\n    color: red;\r\n    position: absolute;\r\n    margin-top: -10px;\r\n}\r\n\r\n.btn-add-asset-bottom {\r\n    margin: 5px 0px 5px 0px;\r\n    background-color: #1fa300;\r\n    color: white;\r\n    font-size: 16px !important;\r\n    padding: 6px !important;\r\n    border-radius: 3px !important;\r\n\r\n}\r\n\r\n.btn-add-wo {\r\n    background-color: #1fa300;\r\n    margin: -5px 70px 0px 8px;\r\n    color: white;\r\n    font-size: 16px !important;\r\n    padding: 6px !important;\r\n    border-radius: 3px !important;\r\n    float: right;\r\n}\r\n\r\n.btn-add-wo-only {\r\n    background-color: #1fa300;\r\n    margin: -5px 0px 0px 8px;\r\n    color: white;\r\n    font-size: 16px !important;\r\n    padding: 6px !important;\r\n    border-radius: 3px !important;\r\n    float: right;\r\n}\r\n\r\n.btn-disable {\r\n    opacity: 0.5;\r\n    pointer-events: none;\r\n    display: none;\r\n}\r\n\r\n.div-block {\r\n    display: block;\r\n}\r\n\r\n.div-hidden {\r\n    display: none;\r\n}\r\n\r\nul.timeline {\r\n    list-style-type: none;\r\n    position: relative;\r\n}\r\n\r\nul.timeline:before {\r\n    content: ' ';\r\n    background: #d4d9df;\r\n    display: inline-block;\r\n    position: absolute;\r\n    left: 29px;\r\n    width: 2px;\r\n    height: 100%;\r\n    z-index: 400;\r\n}\r\n\r\nul.timeline>li {\r\n    margin: 20px 0;\r\n    /* padding-left: 20px; */\r\n}\r\n\r\nul.timeline>li:before {\r\n    content: ' ';\r\n    background: white;\r\n    display: inline-block;\r\n    position: absolute;\r\n    border-radius: 50%;\r\n    border: 3px solid #22c0e8;\r\n    left: 20px;\r\n    width: 20px;\r\n    height: 20px;\r\n    z-index: 400;\r\n}\r\n\r\n.wo-eye-icon {\r\n    float: left;\r\n    padding: 4px 0px 0px 10px;\r\n    color: #33B8FF;\r\n    cursor: pointer;\r\n}\r\n\r\n.wo-desc-wrap {\r\n    white-space: nowrap;\r\n    width: 100px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n\r\n}\r\n\r\n\r\n\r\n:host ::ng-deep .p-toast,\r\n.h5,\r\nh5 {\r\n    padding: 0 !important;\r\n    padding-left: 5px !important;\r\n}\r\n\r\n.display-padding-left-15 {\r\n    padding-left: 15px;\r\n}\r\n\r\n.display-padding-left-5 {\r\n    padding-left: 5px;\r\n}\r\n\r\n:host ::ng-deep .p-checkbox {\r\n    position: absolute !important;\r\n}\r\n\r\n:host ::ng-deep .p-multiselect-items {\r\n    margin: 0 !important;\r\n}\r\n\r\n:host ::ng-deep .p-dropdown-items {\r\n    margin: 0 !important;\r\n}\r\n\r\n:host ::ng-deep .p-multiselect-item span {\r\n    margin-left: 25px !important;\r\n}\r\n\r\n:host ::ng-deep .p-multiselect-item .p-checkbox .p-checkbox-box span {\r\n    margin-left: 0px !important;\r\n}\r\n\r\n:host ::ng-deep #mlSelDesc .p-multiselect-item {\r\n    white-space: normal;\r\n    width: 100%;\r\n    display: inline-block;\r\n    padding-left: 34px;\r\n    text-indent: -25px;\r\n    min-width: auto !important;\r\n}\r\n\r\n:host ::ng-deep .p-multiselect-item .p-checkbox .p-checkbox-box span {\r\n    padding-left: 35px !important;\r\n}\r\n\r\n:host ::ng-deep .p-checkbox p-component {\r\n    padding-top: 5px !important;\r\n}\r\n\r\n:host ::ng-deep .p-multiselect .p-multiselect-label {\r\n    padding: 0.429rem 0.429rem;\r\n    transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\r\n    max-width: 250px;\r\n}\r\n\r\n:host ::ng-deep .p-overlay {\r\n    width: 100%;\r\n}\r\n\r\n:host ::ng-deep .p-datepicker table th {\r\n    padding: 0.5rem;\r\n    text-align: center;\r\n}\r\n\r\n:host ::ng-deep .p-button-danger {\r\n    color: #f44336;\r\n    border-color: #f44336;\r\n}\r\n\r\n:host ::ng-deep .p-button-danger .pi {\r\n    margin-right: 0.5rem;\r\n}\r\n\r\n.question-text-offset-45 {\r\n    width: calc(100% - 45px);\r\n}\r\n/* Tooltip styling */\r\n\r\n.tooltip-text {\r\n  color: #7f7f7f;\r\n  font-weight: 100;\r\n  margin-left: 2px;\r\n  font-size: 14px;\r\n  font-style: italic;\r\n}\r\n\r\n.tooltip-info {\r\n  color: #007ad9;\r\n}\r\n.tooltip-warning {\r\n  color: #ffcc00;\r\n}\r\n.tooltip-error {\r\n  color: #ed4337;\r\n}\r\n.tooltip-icon {\r\n  margin-left: 2px;\r\n  cursor: pointer !important;\r\n  margin-top: 4px;\r\n}\r\n:host ::ng-deep .p-fileupload .p-fileupload-content {\r\n    border: none !important;\r\n}\r\n\r\n:host ::ng-deep .p-fileupload .p-fileupload-buttonbar {\r\n    border: none !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
